export default "__VITE_ASSET__b0ebdea9__"